(function () {
  var FAQ_HEADING = 'Sıkça Sorulan Sorular';

  function normalize(text) {
    return (text || '').replace(/\s+/g, ' ').trim();
  }

  function collectFaqPairs(root) {
    var headings = root.querySelectorAll('h2');
    var faqHeading = null;

    for (var i = 0; i < headings.length; i++) {
      if (normalize(headings[i].textContent) === FAQ_HEADING) {
        faqHeading = headings[i];
        break;
      }
    }

    if (!faqHeading) return [];

    var entities = [];
    var node = faqHeading.nextElementSibling;

    while (node) {
      if (node.tagName === 'H2') break;

      if (node.tagName === 'H3') {
        var question = normalize(node.textContent);
        var answerNode = node.nextElementSibling;

        while (answerNode && answerNode.tagName !== 'P' && answerNode.tagName !== 'H3' && answerNode.tagName !== 'H2') {
          answerNode = answerNode.nextElementSibling;
        }

        if (answerNode && answerNode.tagName === 'P') {
          var answer = normalize(answerNode.textContent);
          if (question && answer) {
            entities.push({
              '@type': 'Question',
              name: question,
              acceptedAnswer: {
                '@type': 'Answer',
                text: answer,
              },
            });
          }
        }
      }

      node = node.nextElementSibling;
    }

    return entities;
  }

  function injectFaqSchema(root, mainEntity) {
    if (document.getElementById('vibee-article-faq-schema')) return;
    if (!mainEntity.length) return;

    var script = document.createElement('script');
    script.type = 'application/ld+json';
    script.id = 'vibee-article-faq-schema';
    script.textContent = JSON.stringify({
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      mainEntity: mainEntity,
    });

    document.head.appendChild(script);
  }

  function createFaqIcon() {
    var svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    svg.setAttribute('class', 'vibee-faq__icon');
    svg.setAttribute('viewBox', '0 0 24 24');
    svg.setAttribute('aria-hidden', 'true');
    svg.innerHTML =
      '<path d="M6 9l6 6 6-6" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>';
    return svg;
  }

  function transformFaqAccordion(root) {
    var headings = root.querySelectorAll('h2');
    var faqHeading = null;

    for (var i = 0; i < headings.length; i++) {
      if (normalize(headings[i].textContent) === FAQ_HEADING) {
        faqHeading = headings[i];
        break;
      }
    }

    if (!faqHeading) return;

    var node = faqHeading.nextElementSibling;
    var pairs = [];

    while (node) {
      if (node.tagName === 'H2') break;

      if (node.tagName === 'H3') {
        var questionNode = node;
        var answerNode = node.nextElementSibling;

        while (answerNode && answerNode.tagName !== 'P' && answerNode.tagName !== 'H3' && answerNode.tagName !== 'H2') {
          answerNode = answerNode.nextElementSibling;
        }

        if (answerNode && answerNode.tagName === 'P') {
          pairs.push({ question: questionNode, answer: answerNode });
        }
      }

      node = node.nextElementSibling;
    }

    if (!pairs.length) return;

    pairs.forEach(function (pair) {
      var details = document.createElement('details');
      details.className = 'vibee-faq';

      var summary = document.createElement('summary');
      summary.textContent = normalize(pair.question.textContent);
      summary.appendChild(createFaqIcon());

      var answerWrap = document.createElement('div');
      answerWrap.className = 'vibee-faq__answer';
      answerWrap.appendChild(pair.answer.cloneNode(true));

      details.appendChild(summary);
      details.appendChild(answerWrap);

      pair.question.parentNode.insertBefore(details, pair.question);
      pair.question.remove();
      pair.answer.remove();
    });
  }

  function init() {
    var root = document.querySelector('[data-vibee-article-content]');
    if (!root) return;

    var mainEntity = collectFaqPairs(root);
    injectFaqSchema(root, mainEntity);
    transformFaqAccordion(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
